import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Row, Switch } from 'antd';
import _ from 'lodash';
import ExtendedSelect from 'components/extendedSelect';
import DurationPicker from 'components/durationPicker/duration-picker';
import { convertToSelect, getKey, getLabel } from 'library/helpers';
import settings from 'settings';
import { FormWrapper } from 'components/Page';
import REDUCER_KEY from 'reducers/reducer.keys';
import { list } from 'actions';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  notificationTypes: state.api.notificationTypes.data.results,
  inFlight: state.api.notificationTypes.data.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadNotificationTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    return dispatch(list(REDUCER_KEY.notificationTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    type, delta, is_before
  } = dataSource;

  return {
    type: Form.createFormField({ value: convertToSelect(type) }),
    delta: Form.createFormField({ value: delta }),
    is_before: Form.createFormField({ value: is_before })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, form, loadNotificationTypes, notificationTypes, inFlight
}) => {
  const { getFieldDecorator } = form;
  const {
    type, delta, is_before
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <Row {...inputFormItemLayout.row}>
        <FormItem {...inputFormItemLayout} label="Notification Type">
          {getFieldDecorator('type', {
            initialValue: convertToSelect(type),
            rules: [
              {
                required: true,
                message: 'Please select a Notification Type.'
              }
            ]
          })(
            <ExtendedSelect
              placeholder="Select Notification Type"
              fetching={inFlight}
              dataSource={notificationTypes}
              optionKey={getKey}
              optionLabel={getLabel}
              onSearch={loadNotificationTypes}
              onFocus={loadNotificationTypes}
              disabled={readonly}
            />
          )}
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Duration">
          {
            getFieldDecorator('delta', {
              initialValue: delta
            })(
              <DurationPicker disabled={readonly} minuteStep={5} />
            )
          }
        </FormItem>
        <FormItem {...inputFormItemLayout} label="Run Before">
          {
            getFieldDecorator('is_before', {
              initialValue: is_before,
              valuePropName: 'checked'
            })(
              <Switch disabled={readonly} checkedChildren="Yes" unCheckedChildren="No" />
            )
          }
        </FormItem>
      </Row>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  inFlight: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  loadNotificationTypes: PropTypes.func,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  notificationTypes: PropTypes.array
};

FormInput.defaultProps = {
  canAdmin: false,
  inFlight: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  loadNotificationTypes() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  },
  notificationTypes: []
};

const ConnectedFormInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormInput);

const NotificationInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default NotificationInput;
